import React from 'react';
import { Route } from 'react-router-dom';
import { PrivacyPolicy } from './PrivacyPolicy';
import { RegisterByQR } from './RegisterByQR';
import { TermsOfUse } from './TermsOfUse';

export const PublicRouting = [
  <Route key="privacy-policy" path="/privacy-policy" element={<PrivacyPolicy />} />,
  <Route key="register" path="/register" element={<RegisterByQR />} />,
  <Route key="terms-of-use" path="/terms-of-use" element={<TermsOfUse />} />,
];
